(function (module) {
    module.directive('googlePlace', function () {
        return {
            require: 'ngModel',
            scope: {
                ngModel: '=',
                details: '=?'
            },
            link: function (scope, element, attrs, model) {
                // Yandex.Maps API'sini başlat
                ymaps.ready(function () {
                    // Suggest API'sini kullan
                    var suggestView = new ymaps.SuggestView(element[0], {
                        results: 5, // Öneri sayısı
                        boundedBy: [[attrs.minLat || -90, attrs.minLng || -180], [attrs.maxLat || 90, attrs.maxLng || 180]]
                    });

                    // Seçim yapıldığında
                    suggestView.events.add('select', function (e) {
                        var selectedItem = e.get('item');
                        var value = selectedItem.value;

                        // Seçilen yerin detaylarını al
                        ymaps.geocode(value).then(function (res) {
                            var firstGeoObject = res.geoObjects.get(0);
                            var coords = firstGeoObject.geometry.getCoordinates();
                            var bounds = firstGeoObject.properties.get('boundedBy');

                            // Adres bileşenlerini al
                            var components = {
                                country: firstGeoObject.getCountry(),
                                administrative_area: firstGeoObject.getAdministrativeAreas(),
                                locality: firstGeoObject.getLocalities(),
                                thoroughfare: firstGeoObject.getThoroughfare(),
                                premise: firstGeoObject.getPremise()
                            };

                            // Detay objesi oluştur
                            var details = {
                                latitude: coords[0],
                                longitude: coords[1],
                                formatted: value,
                                address: value,
                                country: components.country,
                                city: components.locality ? components.locality[0] : '',
                                state: components.administrative_area ? components.administrative_area[0] : '',
                                street: components.thoroughfare,
                                number: components.premise,
                                bounds: bounds
                            };

                            // Scope'u güncelle
                            scope.$apply(function () {
                                scope.details = details;
                                model.$setViewValue(details);
                            });
                        });
                    });
                });
            }
        };
    });
}(angular.module("google.places", [])));